import * as Ariakit from '@ariakit/react';
import { getClassNames } from '@websolutespa/bom-core';
import { forwardRef, useContext } from 'react';
import styled from 'styled-components';
import { getVariantKey } from '../../variants';
import { UIStyledComponentProps } from '../types';
import { getCssResponsive } from '../utils';
import { AccordionContext } from './accordion.context';
import { IAccordionVariants, accordionVariants } from './accordion.variants';

const AccordionContentStyle = styled(Ariakit.DisclosureContent) <AccordionContentProps>`
  ${props => getVariantKey('content', props.variant, props.variants)}
  ${props => getCssResponsive(props)}
`;

export type AccordionContentProps = Ariakit.DisclosureContentProps & UIStyledComponentProps<{
  className?: string;
  variant?: keyof typeof accordionVariants | (string & {});
  variants?: IAccordionVariants;
}>;

export const AccordionContent = forwardRef<HTMLDivElement, AccordionContentProps>(
  function AccordionContent({ className, children, variant, variants, ...props }, ref) {
    const classNames = getClassNames('accordion__content', className);
    const context = useContext(AccordionContext);
    return (
      <AccordionContentStyle
        className={classNames}
        variant={variant || context.variant}
        variants={variants || context.variants}
        ref={ref}
        {...props}
      >
        <div className="accordion__clipped">
          <div className="accordion__inner">
            {children}
          </div>
        </div>
      </AccordionContentStyle>
    );
  }
);
